import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "rightSlot"];
import { Box } from 'foundations-components/transitional/components/Box';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FiltersCard = _ref => {
  let {
      children,
      rightSlot
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    padding: "300"
  }, options, {
    children: /*#__PURE__*/_jsxs(TFlex, {
      gap: 16,
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 1,
        children: /*#__PURE__*/_jsx(TFlex, {
          gap: 16,
          children: children
        })
      }), rightSlot && /*#__PURE__*/_jsx(Box, {
        children: rightSlot
      })]
    })
  }));
};